import { Icon, Text } from '../atoms'
import { useNavigation, useTheme } from '@react-navigation/native'
import React from 'react'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Theme } from '@theme'
import { getCommonStyles } from '@utils'
import type { AppNavigationProp } from '../../navigation/navigationTypes'
import { useLanguage } from '@context'
import { useScreen } from '@hooks'

export const BackButtonWeb = ({title, onPress}: {title?: string, onPress?: () => void}) => {
  const theme = useTheme()
  const navigation = useNavigation<AppNavigationProp>()
  const commonStyles = getCommonStyles(theme)
  const { t } = useLanguage()
  const { isWeb } = useScreen()

  return (
    <TouchableOpacity
      style={[commonStyles.row, { marginLeft: theme.spacing.lg}, isWeb && { marginTop: theme.spacing.lg }]}
      onPress={
        onPress
          ? onPress
          : () => {
              if (navigation.canGoBack()) {
                navigation.goBack()
              } else {
                // Deep-link opened directly (no history): fallback to a safe default
                navigation.reset({ index: 0, routes: [{ name: 'Tab' }] })
              }
            }
      }
    >
      <Icon name="arrowBack" color={theme.colors.secondary} />
      <Text type="bodySmall" color={theme.colors.secondary}>{title || t('common.back')}</Text>
    </TouchableOpacity>
  )
}
export const BackButton = ({noOffset = false, rounded = false, title}: {noOffset?: boolean, rounded?: boolean, title?: string}) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const { top } = useSafeAreaInsets()
  const navigation = useNavigation<AppNavigationProp>()
  
  return (
    <TouchableOpacity
      style={[styles.iconBack, rounded && styles.iconBackRounded, !noOffset && {top: top || theme.spacing.lg}]}
      onPress={() => {
        if (navigation.canGoBack()) {
          navigation.goBack()
        } else {
          navigation.reset({ index: 0, routes: [{ name: 'Tab' }] })
        }
      }}
    >
        <Icon name='arrowBack' color={theme.colors.secondary}/>
        {!!title && <Text type="bodySmall" color={theme.colors.secondary}>{title}</Text>}
    </TouchableOpacity>
  )
}

const getStyle = (theme: Theme) =>
    StyleSheet.create({
      iconBack: {
        position: 'absolute',
        left: theme.spacing.lg,
        flexDirection: 'row',
        gap: theme.spacing.sm,
        alignItems: 'center',
        zIndex: 1
      },
      iconBackRounded: {
        backgroundColor: theme.colors.white,
        borderRadius: 20,
        borderColor: theme.colors.primary,
        borderWidth: 1,
      }
}) 